<script setup lang="ts">
   import type { RouterLinkProps } from 'vue-router';
   //props
   import NuxtTypedLink from '~/components/NuxtTypedLink.vue';

   const { to, icon } = defineProps<{
      to: RouterLinkProps['to'];
      icon?: string;
   }>();
</script>

<template>
   <li class="flex">
      <NuxtTypedLink
         :to="to"
         class="flex items-center justify-between whitespace-nowrap border-b-[3px] border-transparent bg-transparent p-3 text-xs font-bold uppercase text-gray-400 hover:border-brand-primary hover:text-black">
         <slot />
      </NuxtTypedLink>
   </li>
</template>

<style scoped></style>
